<template>

<div v-if='isReady' class="client-list row mt-2">

    <div v-if='$parent.phase.type == "auction"' v-for="(o,i) in offers" class="col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-4">
        <div class="auction-item list-item shadow h-100 text-center">
            <div class="list-info">
                <div v-if="i == 0" class="best-proposial">
                    <span class="text">Най-добро предложение</span>
                    <span class="icon icon-info popover-trigger"
                        data-toggle="popover" data-html="true" 
                        data-placement="top" 
                        data-container="body" 
                        data-trigger="focus"
                        data-original-title="" 
                        data-content="Избрано на база зададените от теб предпочитания за цена, срок и рейтинг на изпълнител при създаване на проекта."></span>
                </div>
                <div class="list-header pt-3 pl-4 pr-4 pb-2">
                    <h6 class="mb-1">
                        <a :href='"/contractors/" + o.uid' target='_blank'>
                            {{ o.user }}

                            <span v-if='o.brand'>
                                ( {{ o.brand }} )
                            </span>
                        </a>  


                    </h6>
                    <user-rating v-if="o.rating" :rating='o.rating'></user-rating>
                    <p> Резултат: {{ o.score }} </p>
                </div>
                <div class="list-body pb-2 pl-4 pr-4 pt-3">
                    <div class="auction-price">{{ o.cost }} лв.</div>
                    <div class="auction-time">
                        <span class="capt">Срок на изпълнение:</span>
                        <span class="cont">{{ o.time }} дни</span>
                    </div>
                </div>
                <div class="list-footer pl-4 pr-4 pt-2 pb-4">
                    <button @click='selectWinner(o)' class="btn btn-outline-secondary btn-sm" :disabled='isLoading'>
                        Избери офертата
                    </button>
                </div>
            </div>
        </div>
    </div>
   

    <div class="col-12" v-if='$parent.phase.type == "competition"'>
        <div class="row">
            <div class="col-12">
                <div class="alert alert-info mb-4">
                    <div>
                        <h6 class="mt-2 mb-1">Идейните предложения те очакват</h6>
                        <p class="normal-text">
                            За да завършиш успешно този етап, е необходимо да дадеш оценка чрез петте критерия на поне три от получените предложения. Тази оценка ще се визуализира в листинга, за да ти помогне да избереш победител, а на дизайнерите ще даде обратна връзка. <br />
                            Избирането на първите три места става чрез бутоните 1, 2 и 3. Номер 1 ще бъде и твоят победител.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div  v-for="(o,i) in offers" class="col-xl-4 col-sm-6 mb-4 mt-2">            
                <div v-if="o.finished == 0 || !o.image_thumb" class="list-item shadow-lg h-100 list-waiting d-flex 
                    justify-content-center align-items-center">
                    <div class="inner text-green text-center pl-4 pr-4 pt-5 pb-5">
                        <span class="icon icon-loader d-block mb-4"></span>
                        <span class="text">Предложението е в процес на изработка.</span>
                    </div>
                </div>

                <div v-else-if="o.finished == 1" class="list-item shadow-lg h-100">
                    <div class="list-img">
                        <a :href="'/project-idea/' + o.id" class="lp-box-link" target="_blank">
                            
                            <img v-if='o.finished == 1' class="img-responsive" :src="o.image_thumb" :alt="o.title">

                            <span class="overlay d-flex align-items-center justify-content-center">
                                <span class="overlay-inner text-center">
                                    <span class="icon icon-chevrons-right"></span>
                                    <span class="text mt-3">Виж повече</span>
                                </span>
                            </span>   

                            <div v-if='o.place' class="num-place">
                               #{{ o.place }}
                            </div>                         
                        </a>
                    </div>
                    <div class="list-info pl-4 pr-4 pt-3 pb-3">
                        <h6 class="mb-0">
                            <a :href="'/projects/ip/' + o.id" target="_blank">{{ o.title }}</a>
                        </h6>
                        <div v-if='!o.score' class="text-orange">  
                            <span class="icon icon-alert-triangle"></span>
                            Очаква оценка
                        </div>
                        <div v-if='o.score' class="text-orange">
                            Оценка: {{ o.score }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if='!offers.length' class="col-12 alert alert-info">
        За съжаление няма подадени оферти за този етап.
    </div>

    <loading-div v-if='!isReady'></loading-div>
</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {

            return {
                isReady : false,
                isLoading : false,
                offers  : [],
            }

        },

        methods : {

            getData() {
                var me = this;

                me.ajax.call('phs:gfof', { pp : this.$parent.$parent.projectPhase.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        me.offers = r.data;
                    }

                    me.isReady = true;

                })

            },

            selectWinner( o ) {
                if( !confirm('Сигурни ли се, че искате да изберете тази оферта за победител?') ) {
                    return;
                }

                var me = this;

                me.isLoading = true;

                this.ajax.call('phs:swn', { o : o.id, pp : this.$parent.$parent.projectPhase.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        $.notify("Успешно посочихте победител в този етап на проекта!","success");

                        bus.$emit("update-phase", { user_id : o.user_id });
                        
                        me.isLoading = false;
                    }

                });

            }

        }

    }
</script>
